import { gql } from "@apollo/client";

// receipt_track stores the phone/email a customer actually typed to receive an
// SMS/email receipt. We use it to backfill the Phone Number column on the
// transactions report and order search, where order_payment.phone_number is
// frequently empty or "N/A". Join key: receipt_track.reference_id maps to
// order_payment.reference_id.
export const RECEIPT_TRACK_PHONES = gql`
  query receiptTrackPhones($where: receipt_track_bool_exp!) {
    receipt_track(where: $where, order_by: { created_at: desc }) {
      reference_id
      phone_number
    }
  }
`;
